import React from 'react';

function fmt(ts) {
  return ts ? new Date(ts).toLocaleString() : '—';
}

/** Recent run history table for the selected farm. */
export default function RunHistory({ runs, selectedRunId, onSelectRun, showScenario = false }) {
  if (!runs || !runs.length) {
    return (
      <div className="card history">
        <h3>History</h3>
        <p className="muted">No runs yet.</p>
      </div>
    );
  }

  return (
    <div className="card history">
      <h3>History</h3>
      <table>
        <thead>
          <tr>
            <th>Status</th>
            {showScenario && <th>Test name</th>}
            <th>Started</th>
            <th>Completed</th>
            <th>Triggered by</th>
          </tr>
        </thead>
        <tbody>
          {runs.map((r) => (
            <tr 
              key={r.RunId} 
              onClick={() => onSelectRun(r)}
              className={selectedRunId === r.RunId ? 'selected-row' : 'clickable-row'}
              style={{ cursor: 'pointer' }}
            >
              <td>
                <span className={`badge ${(r.Status || '').toLowerCase()}`}>
                  {r.Status}
                </span>
              </td>
              {showScenario && <td>{r.ScenarioName || '—'}</td>}
              <td>{fmt(r.StartedAt)}</td>
              <td>{fmt(r.CompletedAt)}</td>
              <td>{r.TriggeredBy || '—'}</td>
            </tr>
          ))}
        </tbody>
      </table>
      {selectedRunId && (
        <p className="hint">👆 Click another row to view different run details</p>
      )}
    </div>
  );
}
